import React from 'react';
import { formatEur, tndToEur } from '../../utils/currency';
import './ServicePriceRows.css';

// Libellés des tarifs — mêmes conventions que la liste admin /admin/services
const TYPE_LABELS = { professional: 'Professionnelle', certified: 'Certifiée', sworn: 'Assermentée' };
const METHOD_LABELS = { document: 'document', page: 'page', word: 'mot' };
const UNIT_NAMES = {
  document: 'Document', page: 'Page', word: 'Mot',
  hour: 'Heure', halfday: 'Demi-journée', day: 'Journée', service: 'Mission', '': 'Tarif',
};
const UNIT_SUFFIX = {
  document: 'par document', page: 'par page', word: 'par mot',
  hour: 'par heure', halfday: 'par demi-journée', day: 'par journée', service: 'par mission',
};

// Entrées de prix exploitables : prices (Map/objet) sinon repli basePrice+unit.
export function servicePriceEntries(svc) {
  const p = svc?.prices || {};
  const entries = Object.entries(p).filter(([, v]) => Number(v) > 0);
  const fallback = Number(svc?.basePrice ?? svc?.price) || 0;
  if (!entries.length && fallback > 0) entries.push([svc?.unit || '', fallback]);
  return entries;
}

/**
 * Lignes de tarifs à badge coloré (type de traduction ou unité) :
 *   ● Professionnelle   30 TND   8,96 €   par document
 * Accepte un service DB (typePricing/prices/priceEur/unit/basePrice)
 * ou un objet minimal { price, unit }.
 */
export default function ServicePriceRows({ service, locale = 'fr-FR' }) {
  const eur = (tnd, configured) => (Number(configured) > 0
    ? `${configured} €`
    : formatEur(tndToEur(Number(tnd)), locale));

  const typePrices = (service?.typePricing || []).filter((e) => Number(e.price) > 0);
  if (typePrices.length) {
    return (
      <div className="svc-price-rows">
        {typePrices.map((e) => (
          <div key={e.type} className={`svc-price-row svc-price-row--${e.type}`}>
            <span className="svc-price-row-label">{TYPE_LABELS[e.type] || e.type}</span>
            <span className="svc-price-row-vals">
              <strong>{e.price} TND</strong>
              <span>{eur(e.price, e.priceEur)}</span>
              <em>par {METHOD_LABELS[e.method] || 'document'}</em>
            </span>
          </div>
        ))}
      </div>
    );
  }

  const entries = servicePriceEntries(service);
  if (!entries.length) return null;

  return (
    <div className="svc-price-rows">
      {entries.map(([u, p]) => (
        <div key={u || 'fixed'} className="svc-price-row">
          <span className="svc-price-row-label">{UNIT_NAMES[u] || 'Tarif'}</span>
          <span className="svc-price-row-vals">
            <strong>{p} TND</strong>
            <span>{eur(p, service?.priceEur)}</span>
            {UNIT_SUFFIX[u] ? <em>{UNIT_SUFFIX[u]}</em> : null}
          </span>
        </div>
      ))}
    </div>
  );
}
